export const createRedirectSearch = (url: URL | Location): string => {
  const redirect = url.pathname && url.pathname !== '/' ? `redirect=${url.pathname}` : '';
  const params = redirect !== '' && url.search ? `&params=${encodeURIComponent(url.search)}` : '';

  return redirect.concat(params);
};
